import axios from 'axios';
import app from '../assets/json/metadata';

const setAPIBaseUrl = () => {
  const baseUrl =
    process.env.NODE_ENV === 'production'
      ? app.build_env === 'production'
        ? 'https://api-sso.bizapp.co/'
        : 'https://api-sso-dev.bizapp.co/'
      : 'http://localhost:5500';
  axios.defaults.baseURL = baseUrl;
};

export default setAPIBaseUrl;
